/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { Link } from "react-router-dom";

import type { FC } from "react";

type Props = {
  href: string;
  label: string;
};

export const MobileBreadcrumbNavigation: FC<Props> = ({ href, label }) => {
  const classes = styles();

  return (
    <nav css={classes.root}>
      <Link to={href} css={classes.link}>
        <KeyboardArrowLeftIcon css={classes.icon} aria-hidden="true" />
        <span>{label}</span>
      </Link>
    </nav>
  );
};

const styles = () => ({
  root: css`
    background-color: #fff;
    border-bottom: 1px solid #d2d2d2;
  `,
  link: css`
    display: flex;
    box-sizing: border-box;
    align-items: center;
    gap: 4px;
    width: 100%;
    padding: 12px 4%;
    color: #222;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;
    text-decoration: none;
  `,
  icon: css`
    margin-left: -4px;
    font-size: 18px;
  `,
});
